import Button from "@mui/material/Button";
import { darken, styled } from "@mui/material/styles";

const CustomizedComponent = styled(Button, { shouldForwardProp: prop => prop !== "color" })(
  ({ theme, color }) => ({
    // backgroundColor: theme.palette[color].main,
    "&:hover": {
      transform: "scale(1.025)",
      backgroundColor: darken(theme.palette[color].main, 0.15),
      "@media (hover: none)": {
        backgroundColor: theme.palette[color].main,
      },
    },
    "&:active, &:active &:hover": {
      transform: "scale(.975)",
    },
    // color: theme.palette[color].contrastText,
    boxShadow: theme.shadows[4],
    width: "auto", // assure the correct width for iOS Safari
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    borderRadius: 48 / 2,
    paddingRight: "16px",
    paddingLeft: "16px",
    minHeight: 48,
    minWidth: 48,
    height: "auto",
    "& .Mui-sizeSmall": {
      width: "auto",
      padding: 0,
      paddingLeft: 10,
      paddingRight: 14,
      borderRadius: 34 / 2,
      minWidth: 34,
      height: 34,
    },
    "& .MuiSvgIcon-root": {
      height: 32,
      width: 32,
    },
    "& span.MuiTypography-caption": {
      padding: theme.spacing(1),
      borderRadius: theme.spacing(2),
      width: "100%",
      fontSize: "10px",
      lineHeight: "1.5em",
      backgroundColor: darken(theme.palette[color].main, 0.075),
      marginTop: theme.spacing(0.5),
    },
  }),
);

const AssessmentValueTextFab = props => {
  return <CustomizedComponent {...props} />;
};

export default AssessmentValueTextFab;
